import * as Icons from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function ServicesSection({ services }) {
  const { t } = useSite();
  return (
    <section id="layanan" className="py-16 sm:py-24" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 grid gap-6 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-4">{t("svc.eyebrow")}</p>
            <h2 className="text-3xl font-bold tracking-tight text-[#0F2B48] lg:text-4xl">{t("svc.title")}</h2>
          </div>
          <p className="self-end text-slate-600 lg:col-span-6 lg:col-start-7">{t("svc.desc")}</p>
        </div>
        <div className="grid grid-cols-1 gap-px border border-slate-200 bg-slate-200 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.FileCheck2;
            return (
              <article key={s.id} data-testid={`service-card-${s.slug || i}`} className={`group relative bg-white p-8 transition-colors hover:bg-[#0F2B48] ${i === 0 ? "lg:row-span-2" : ""}`}>
                <div className="mb-8 flex items-start justify-between">
                  <span className="grid h-12 w-12 place-items-center border border-slate-200 text-[#D97706] transition-colors group-hover:border-white/20"><Icon size={22} /></span>
                  <span className="font-mono text-xs text-slate-400 group-hover:text-white/50">0{i + 1}</span>
                </div>
                <h3 className="text-xl font-semibold text-[#0F2B48] transition-colors group-hover:text-white">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600 transition-colors group-hover:text-slate-300">{s.short}</p>
                <ul className="mt-6 space-y-2">
                  {(s.features || []).map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-slate-700 transition-colors group-hover:text-slate-200">
                      <Icons.Check size={14} className="mt-1 shrink-0 text-[#D97706]" /> {f}
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
